import { Button } from '@shared/components/ui/button';
import { useTranslation } from 'react-i18next';

interface LocateActionButtonsProps {
  onBack: () => void;
  isBackDisabled?: boolean;
}

export const LocateActionButtons = ({ onBack, isBackDisabled = false }: LocateActionButtonsProps) => {
  const { t } = useTranslation('receiveModule');

  return (
    <div className="absolute right-4 top-2 flex gap-2">
      <Button
        variant="outline"
        size="lg"
        onClick={onBack}
        disabled={isBackDisabled}
        data-testid="back-to-receive-button"
      >
        {t('ui.back_button')}
      </Button>
    </div>
  );
};
